import { mdiDomain } from '@mdi/js'

export default [
  {
    title: 'Company',
    to: 'company-list',
    icon: mdiDomain,
  },
]
